import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractSigningCertificateOfCompletion.Import.IRequest;
type Response = Api.Core.ContractSigningCertificateOfCompletion.Import.IResponse;
type Headers = Api.Core.ContractSigningCertificateOfCompletion.Import.IHeaders;
const url = '/api/Sales/Contract/:id/SigningCertificateOfCompletion/Import';
export default async function contractSigningCertificateOfCompletionImportApi(
  body?: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id: body?.contractId }),
    headers: getDefaultHeaders(),
  });
}
